import React from "react";
import styles from "../css/b2b-advertising.black-and-blue.module.scss";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { FixButton } from "@/elements-react/fix-button";
import mainImage from "@/assets/Cart_2X.webp";
import onePlatformIcon from "@/assets/one-platform.svg";
import fasterDecisionsIcon from "@/assets/faster-desicions.svg";
import fullVisibilityIcon from "@/assets/fullp-visibility.svg";
import growUpIcon from "@/assets/grow-up.svg";
import { Icon } from "@/elements-react/fix-icon";
import {B2BAdvertisingProps} from "@/elements-react/b2b-advertising";
import {Url} from "@/helpers/url.ts";


export const B2bAdvertisingBlackAndBlue: React.FC<B2BAdvertisingProps> = ({ className, onButtonClick }) => {
    const { t } = useTranslation();

    const benefits = [
        {
            icon: onePlatformIcon,
            title: t("b2b_advertising.one_platform.title", "One platform instead of emails and spreadsheets"),
            description: t("b2b_advertising.one_platform.description", "Manage ordering without emails, calls or manual coordination"),
        },
        {
            icon: fasterDecisionsIcon,
            title: t("b2b_advertising.faster_decisions.title", "Faster decisions with instant alternatives"),
            description: t("b2b_advertising.faster_decisions.description", "Instant access to analogues, prices and delivery times"),
        },
        {
            icon: fullVisibilityIcon,
            title: t("b2b_advertising.full_visibility.title", "Full visibility over orders, deliveries"),
            description: t("b2b_advertising.full_visibility.description", "Track every order, delivery and document in one place"),
        },
        {
            icon: growUpIcon,
            title: t("b2b_advertising.built_to_scale.title", "Built to scale with your business"),
            description: t("b2b_advertising.built_to_scale.description", "Works for small teams and scales with growing order volumes"),
        },
    ];

    return (
        <div className={classNames(styles.container, className)}>
            <div className={styles.heading}>
                <h2 className={styles.title}>{t("b2b_advertising.title", "B2B ordering system")}</h2>
                <div className={styles.subtitle}>
                    {t("b2b_advertising.subtitle", "Designed for professionals who value speed and accuracy in every order")}
                </div>
            </div>

            <div className={styles.contentBlock}>
                <img src={mainImage} alt="B2B Ordering System Interface" className={styles.mainImage} />
                <div className={styles.benefitsList}>
                    {benefits.map((benefit, index) => (
                        <div key={index} className={styles.benefitItem}>
                            <Icon src={benefit.icon} className={styles.benefitIcon} width={32} height={32} />
                            <h3 className={styles.benefitTitle}>{benefit.title}</h3>
                            <p className={styles.benefitContent}>{benefit.description}</p>
                        </div>
                    ))}
                </div>
            </div>

            <div className={styles.buttonContainer}>
                <FixButton variant="primary" size="large" href={Url.to("b2b-platform")} onClick={onButtonClick}>
                    {t("b2b_advertising.learn_more", "Learn more about B2B")}
                </FixButton>
            </div>
        </div>
    );
};